"use client";

import React from "react";

//Styled
import * as S from "./styles";

//Types
import { RankingListProps } from "@/types";
import { getFileUrl } from "@/utils/getFileUrl";
import { formatCurrency } from "@/utils/formatCurrency";
import { buildAvatarSrc } from "@/utils/buildAvatarSrc";

const RankingList: React.FC<RankingListProps> = ({ data, className }) => {
  return (
    <S.List className={className}>
      {data.slice(0, 5).map((item, index) => (
        <S.ListItem key={index}>
          <S.FirstBox>
            <S.BoxRank>
              {(() => {
                // prioridade: image -> avatar_url/path -> files[0] -> icon -> rank number
                const directImage = item.image as any;
                const avatar = buildAvatarSrc({
                  avatar_url: item.avatar_url,
                  avatar_path: item.avatar_path,
                });
                const fileUrl =
                  item.files && item.files.length > 0
                    ? getFileUrl(item.files[0])
                    : "";

                if (directImage) return <S.ImageComponent src={directImage} />;
                if (avatar) return <S.ImageComponent src={avatar} />;
                if (fileUrl) return <S.ImageComponent src={fileUrl} />;
                if (item.icon) return item.icon;
                return index + 1;
              })()}
            </S.BoxRank>
            {item.icon ? item.icon : null}
            <S.BoxInfoList>
              <S.UserName>{item.name}</S.UserName>
              <S.DescriptionUser>{item.description}</S.DescriptionUser>
            </S.BoxInfoList>
          </S.FirstBox>
          <S.LastBox>
            <S.LastContent>
              {formatCurrency(Number(item.value), "R$")}
            </S.LastContent>
          </S.LastBox>
        </S.ListItem>
      ))}
    </S.List>
  );
};

export default RankingList;
